import { Injectable } from '@angular/core';
import { HttpClient,HttpParams} from '@angular/common/http';
import { Observable } from 'rxjs';
import { baseURL, getHeaders, VERSION } from '../constant/constant';
import { ResponseBase } from '../constant/response';
import { PageResponseDTO } from '../dtos/PageResponseDTO';

export interface AnonymousFeedbackPayload {
  feedback: string;
  createdBy: number | null;
}

export interface AnonymousFeedbackResponse {
  id: number;
  feedback: string;
  submittedOn: string;
}

@Injectable({
  providedIn: 'root'
})
export class AnonymousFeedbackService {
  constructor(private http: HttpClient) {}

  create(payload: AnonymousFeedbackPayload): Observable<ResponseBase<AnonymousFeedbackPayload>> {
    return this.http.post<ResponseBase<AnonymousFeedbackPayload>>(
      `${baseURL}feedback/${VERSION}`,
      payload,
      getHeaders()
    );
  }

  list(pageNo: number, pageSize: number): Observable<ResponseBase<PageResponseDTO<AnonymousFeedbackResponse>>> {
    const params = new HttpParams()
    .set('page', pageNo.toString())
    .set('size', pageSize.toString());
    return this.http.get<ResponseBase<PageResponseDTO<AnonymousFeedbackResponse>>>(
      `${baseURL}feedback/${VERSION}/list`,
      {
      headers: getHeaders().headers,
      params
      }
    );
  }

  myFeedback(userId: number): Observable<ResponseBase<AnonymousFeedbackResponse[]>> {
    return this.http.get<ResponseBase<AnonymousFeedbackResponse[]>>(
      `${baseURL}feedback/${VERSION}/my?userId=${userId}`,
      getHeaders()
    );
  }

  export(): Observable<ResponseBase<string>> {
    return this.http.get<ResponseBase<string>>(
      `${baseURL}feedback/${VERSION}/export`,
      getHeaders()
    );
  }
}
